import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { OrderDetailProductSkeleton } from "./OrderDetailProductSkeleton";
import { OrderDetailSummary } from "./OrderDetailSummary";

export const OrderDetailSkeleton = () => {
  return (
    <div className="row pb-3">
      <OrderDetailProductSkeleton />
      <OrderDetailSummary />
    </div>
  );
};
